import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const NarrativeViewSettingsRecord = Record({
  showIdentifier: false,
  showDates: false,
  showDuration: false,
  showNarrative: true,
  showRelationshipTypes: List(),
  showBlocks: false,
  showBlockedBy: false,
  showImage: false,
  showSummary: false,
  showInfoIcons: false,
  columnLevel: 1
});

const data = {
  objects: {
    showRelationshipTypes: "List"
  }
};
createFromJS.registerCallback(
  "NarrativeViewSettingsRecord",
  createFromJS.createNestedCallback(NarrativeViewSettingsRecord, data)
);
